export default "__VITE_ASSET__DCgmiBzD__"